export default class Contact {

  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.contact--form')
    if (!this.form) return

    this.mailer = '/wp-content/themes/cafe-de-la-place/mailer/send-mail.php'

    this.bindCheckboxes()
    this.bindSubmit()
  }

  bindCheckboxes() {
    this.el.querySelectorAll('.contact--checkbox-container').forEach(container => {
      container.addEventListener('click', (e) => {
        // un clic direct sur l'input est déjà géré nativement
        if (e.target.matches('.contact--input-checkbox')) return
        const checkbox = container.querySelector('.contact--input-checkbox')
        checkbox.checked = !checkbox.checked
      })
    })
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam && amispam.value) {
        console.error('Oh no ! I m Spam')
        return
      }

      const formData = new FormData(this.form)

      const options = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }

      this.setState('loading')

      fetch(this.mailer, options)
        .then(response => {
          if (!response.ok) throw new Error(`Envoi impossible (${response.status})`)
          this.setState('sent')

          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
          }, 5000)
        })
        .catch(error => {
          console.error(error)
          this.setState('submit')
        })
    })

    this.form.querySelectorAll('.contact--submit.is-loading, .contact--submit.is-sent').forEach(btn => {
      btn.addEventListener('click', e => e.preventDefault())
    })
  }

  setState(state) {
    this.form.querySelectorAll('.contact--submit').forEach(btn => btn.classList.remove('is-active'))
    const target = this.form.querySelector(`.contact--submit.is-${state}`)
    if (target) target.classList.add('is-active')
  }

}
